import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wave-one',
  templateUrl: './wave-one.component.html'
})
export class WaveOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
